export default __webpack_public_path__ + "static/media/codeSnap2.17427722.PNG";